import axios from "@/axios";

const endpoint = `/usage`;

const Usage = {
  getCurrentUsage: async () => {
    return axios
      .get(`${endpoint}/current`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        if (error.response) {
          console.log("[usage] getCurrentUsage failed:", {
            status: error.response.status,
            data: error.response.data,
          });
        } else {
          console.log("[usage] getCurrentUsage failed:", error.message);
        }
        return null;
      });
  },

  getOrgUsage: async (orgId) => {
    return axios
      .get(`/organizations/${orgId}/usage/current`)
      .then((res) => res)
      .catch((error) => {
        console.log("[usage] getOrgUsage failed:", error);
        return null;
      });
  },
};

export default Usage;